export class CmpsCommitmentSummaryContext {
    showActionButtons?: boolean;
    showActionLabel?: boolean;
}
